import BaseLayout from '../base/base_layout';
import Model from './loggedin_inline_layout_model';
import DOM from '../../../../utils/dom';
import _ from '../../../../utils/underscore';
import {CASHIER_ACTIONS} from '../../../external_links/external_links_consts';
import { SYSTEM_EVENTS } from '../../../../events/events';
import ServiceFactory from '../../../../services/service_factory';
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core/lib/apps/app-enums";

let loggedin = require('./view/loggedin.html');


class LoggedinInlineLayout extends BaseLayout {
    /**
     * @static
     * @type {string}
     */
    static layoutName = 'inline';


    /**
     * Default root cgp component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-loggedin-inline-component';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init();
        if (params) {
            this._stepParent = params.stepParent;
        }
        this._model = Model.create(params);
        this.subscribe();
    }


    getDefaultStyleSelectors() {
        return {
            badge: 'cgp-themes-property-icons-post-login-mobile',
            indicator: 'cgp-fp-omg-indicator-badge-default'
        };
    }


    /**
     *
     * @returns {LoggedinInlineLayout}
     */
    start(params) {
        let bakedHTML = this.bake(loggedin, {
            username: this._getUsername(),
            badgeClass: this.getStyleSelectors().badge,
            indicator: this.getStyleSelectors().indicator
        });

        this
            .setHTML(bakedHTML)

            ._onCashier(); // Should be after baked the html because we need to attach event to something that may not be appear.

        // Get layout loggedin component layout.
        this._createBankrollComponent(params);

        return this;
    }


    /**
     *
     */
    subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.BALANCE_UPDATED, () => { this.start(); });
        this.onSystemEvent(SYSTEM_EVENTS.FREE_PLAY_UPDATED, (data) => {
            this._onFreePlayChanged(data);
        });
        this.onSystemEvent(SYSTEM_EVENTS.OMG_AWAITING_MESSAGES_UPDATED, (omgStatus) => {
            this._onOMGStatusChanged(omgStatus);
        });
        this._onPostCTAClicked();
    }


    /**
     * Set the wallet in the loggedin component.
     *
     * @returns {*}
     * @private
     */
    _createBankrollComponent(params) {
        if (!this._model.getShowBalance()) {
            return this;
        }

        // Get all balance place holders inside loggedin component.
        let balancePlaceHolders = [].slice.call(this.getEl().querySelectorAll('.balance'));

        // Set wallet in the currency format before displaying it on the html.
        let bankroll = ServiceFactory.create().walletService().getBankroll();
        balancePlaceHolders.forEach(balancePlaceHolder => {
            // Append bankroll component dom element inside loggedin component inline template.
            DOM.html(bankroll, balancePlaceHolder);
        });
        this._updateIndicatorStatus();
        return this;
    }


    /**
     * Change indicator status according to free plays and OMG messages status
     * @private
     */
    _updateIndicatorStatus() {
        let badge = this.getDOMElementByClassName('cgp-fp-omg-indicator-badge');
        if (this._isIndicatorOn()) {
            DOM.visible(badge);
        } else {
            DOM.invisible(badge);
        }
    }


    /**
     * Get FreePlay and OMG indicator status
     * @returns {*}
     * @private
     */
    _getIndicatorStatus() {
        return { isFreePlayExist: this._model.getIsNewFreePlay(), isOMGExist: this._model.getIsOMGExist()};
    }


    /**
     * Get if FreePlay and OMG indicator on
     * @returns {*}
     * @private
     */
    _isIndicatorOn() {
        return this._model.getIsFreePlay() || this._model.getIsOMGExist();
    }


    /**
     * Handle free play changes and save the status in model
     * @param freePlay
     * @private
     */
    _onFreePlayChanged(freePlay) {
        let isFPExist = freePlay && _.isArray(freePlay) && freePlay.length > 0;
        this._model.setIsFreePlay(isFPExist);
        this._updateIndicatorStatus();
    }


    /**
     * Handle OMG messages status and save it in model
     * @private
     */
    _onOMGStatusChanged(status) {
        this._model.setIsOMGMessageExist(status > 0);
        this._updateIndicatorStatus();
    }


    /**
     * Set the username in the loggedin component.
     *
     * @returns {*}
     * @private
     */
    _getUsername() {
        if (!this._model.getShowUsername()) {
            return this;
        }

        let username = ServiceFactory.create().userService().getUsername();

        if (!username || !_.isString(username)) {
            this.username = '';
            return this;
        }

        // Set wallet in the currency format before displaying it on the html.
        this.username = username;

        return username;
    }


    /**
     * Open cashier if exist.
     *
     * @private
     */
    _onCashier() {
        if (!this._model.getShowCashier()) {
            return this;
        }

        this.onChildElementEvent('.cgp-cashier', 'click', (event) => {
            event.preventDefault();
            this._sendAnalytics({action: 'Cashier'});
            // to force default behaviour uncomment getting view logic
            // let view = this._model.getCashierOpenType() === 0 ? 'iframe' : 'window';
            this.serviceFactory.cashierProxyService().openCashier({
                sessionType: CASHIER_ACTIONS.FULL_CASHIER,
                channel: {
                    source: CHANNEL_SOURCE.casinoClient,
                    area: AreaType.Header,
                    element: CHANNEL_ELEMENTS.depositButton
                }
            });
        });

        return this;
    }


    /**
     *
     * @private
     */
    _onPostCTAClicked() {
        let postCTAHandler = this._model.getPostCTAClickedFn();
        if (postCTAHandler && _.isFunction(window[postCTAHandler])) {
            this.onRootElementEvent('click', (event) => {
                event.preventDefault();
                this.logger.debug('_onPostCTAClicked');
                window[postCTAHandler].call(window, this._getIndicatorStatus());
            });
        }
        return this;
    }
}

export default LoggedinInlineLayout;